import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api";
import {
  Button,
  TextInput,
  Box,
  Stack,
  Container,
  Text,
  Anchor,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { ContactModal } from "./ContactModal";
import { ForgotPasswordModal } from "./auth/ForgotPasswordModal";
import Footer from "./Footer/Footer";

function Login() {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  const form = useForm({
    initialValues: {
      username: "",
      password: "",
    },
    validate: {
      username: (value) => (value.length > 0 ? null : "Email is required"),
      password: (value) => (value.length > 0 ? null : "Password is required"),
    },
  });

  useEffect(() => {
    const timer = setTimeout(() => setShowForm(true), 50);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleLogin = async (values) => {
    form.setFieldValue("loading", true);
    localStorage.removeItem("access_token");
    try {
      const response = await login(values.username, values.password);
      notifications.show({
        message: "Logged in successfully!",
        color: "green",
        autoClose: 3000,
      });

      if (response.access_token) {
        localStorage.setItem("access_token", response.access_token);
      }

      // Redirect based on user role
      if (response.role === "superuser" || response.role === "admin") {
        window.location.href = "/admin/";
      } else {
        navigate("/app/dashboard");
      }
    } catch (error) {
      console.error("Login failed:", error);
      notifications.show({
        message:
          error.response?.data?.detail ||
          "Login failed. Please check your credentials.",
        color: "red",
        autoClose: 3000,
      });
    } finally {
      form.setFieldValue("loading", false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        position: "relative", // Add this for positioning context
      }}
    >
      {/* Background image div */}
      <div
        style={{
          backgroundImage: "url('/static/socius hero.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "85vh",
          width: "100%",
          position: "fixed",
          top: "68px",
          left: "0px",
          zIndex: -1, // Place it behind other content
        }}
      />

      {/* Content container */}
      <Container
        size="lg"
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4rem 1rem",
        }}
      >
        <Stack
          align="center"
          gap="xl"
          style={{
            position: "relative",
            width: "18rem",
          }}
        >
          <a href="/">
            <img
              src="/static/Socius_Full_DRK.svg"
              alt="Socius Legal"
              style={{
                transition: "transform 0.4s ease",
                transform: showForm ? "translateY(-100px)" : "translateY(0)",
                height: "auto",
                width: "10rem",
              }}
            />
          </a>

          <Box
            className="container"
            p="md"
            style={{
              opacity: showForm ? 1 : 0,
              transition: "opacity 0.4s ease",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
            }}
          >
            <form onSubmit={form.onSubmit(handleLogin)}>
              <Stack spacing="md">
                <TextInput
                  placeholder="Email"
                  required
                  {...form.getInputProps("username")}
                  style={{ textAlign: "center" }}
                />
                <TextInput
                  type="password"
                  placeholder="Password"
                  required
                  {...form.getInputProps("password")}
                  style={{ textAlign: "center" }}
                />
                <Button
                  type="submit"
                  loading={form.values.loading}
                  fullWidth
                  style={{
                    padding: "0.25rem 1rem",
                    fontSize: "1rem",
                    fontWeight: "700",
                  }}
                >
                  Login
                </Button>
              </Stack>
            </form>
            <Stack spacing="xs" mt="md" ta="center">
              <Anchor
                onClick={() => setIsForgotPasswordOpen(true)}
                style={{
                  fontSize: ".8rem",
                  color: "var(--mantine-color-blue-7)",
                }}
              >
                Forgot Password?
              </Anchor>
              <Anchor
                onClick={() => navigate("/register")}
                style={{
                  fontSize: ".8rem",
                  color: "var(--mantine-color-blue-7)",
                }}
              >
                Don't have an account? Register here
              </Anchor>
            </Stack>
          </Box>

          <Button
            onClick={() => setShowForm(true)}
            style={{
              transition: "opacity 0.2s ease, transform 0.2s ease",
              opacity: showForm ? 0 : 1,
              transform: showForm ? "translateY(100px)" : "translateY(0)",
              pointerEvents: showForm ? "none" : "auto",
            }}
          >
            Login
          </Button>
        </Stack>
      </Container>

      {Footer()}

      <ForgotPasswordModal
        opened={isForgotPasswordOpen}
        onClose={() => setIsForgotPasswordOpen(false)}
      />
      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </div>
  );
}

export default Login;
